export class PayoutToken {
    access_Token: string;
    token_Type: string;
    expires_In: number;
    refresh_Token: string;
    scope: string;

}